/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const ZodiacScorpio = createLucideIcon("zodiac-scorpio", [
  ["path", { d: "M10 19V5.5a1 1 0 0 1 5 0V17a2 2 0 0 0 2 2h5l-3-3", key: "1w8g0z" }],
  ["path", { d: "m22 19-3 3", key: "1ix4wq" }],
  ["path", { d: "M5 19V5.5a1 1 0 0 1 5 0", key: "1d4oa3" }],
  ["path", { d: "M5 5.5A2.5 2.5 0 0 0 2.5 3", key: "gp646f" }]
]);

export { ZodiacScorpio as default };
//# sourceMappingURL=zodiac-scorpio.js.map
